import { LeafletCircleMarkerComponent } from './../leaflet-circle-marker/leaflet-circle-marker.component';
import { Component } from '@angular/core';

import * as L from 'leaflet';

@Component({
    selector: 'leaflet-circle',
    template: '',
    standalone: false
})
export class LeafletCircleComponent extends LeafletCircleMarkerComponent {
	
	public override updateLayerGroup(additively: boolean = false): void {
		if (!this._layerGroup) {
			return;
		}

		if (!additively) {
			this._layerGroup.clearLayers();
		}

		let markers = [];

		for (let a = 0; a < this._data.length; a++) {
			const { latitude, longitude, ...options } = this._data[a];
		
			const circle = L.circle(
				[
					latitude,
					longitude
				],
				Object.assign({}, options)
			);

			circle.bindTooltip("<p>What about if it's a long message?</p><p>Second row</p>");

			let popup = L.popup().setContent("Bubble DATA");

			circle.bindPopup(popup);

			circle.on(
				'mouseover',
				function(e) {
					

					circle.setStyle({fillColor: 'green'});
				}
			);

			circle.on(
				'mouseout',
				function(e) {
					

					circle.setStyle({fillColor: 'red'});
				}
			);

			markers.push(circle);
		}

		for (let a = 0; a < markers.length; a++) {
			this._layerGroup.addLayer(markers[a]);
		}
	}
}
